module.exports = __webpack_public_path__ + "static/media/back_of_right_thumb_failed.42b56bb5.svg";